import { del, post, get, makeConstructUrlFromQuery } from './apiUtils';

const defaultUrl = '/InciSubstance/';

export default {
  saveInciSubstance: data => post(`${defaultUrl}`, data),
};
